import { useRef } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import DocsSidebar from '../../components/DocsSidebar'
import OnThisPage from '../../components/OnThisPage'

const NAV = `## Content Cache Proxy
- [Overview & Architecture](/software/content-cache-proxy)
- [Installation & Configuration](/software/content-cache-proxy/installation)
- [Monitoring & Troubleshooting](/software/content-cache-proxy/monitoring)
`

export default function ContentCacheProxy() {
  const location = useLocation()
  const proseRef = useRef<HTMLDivElement>(null)

  return (
    <section className="section api-doc-page">
      <div className="docs-layout">
        <aside className="docs-sidebar">
          <div className="docs-sidebar-inner">
            <DocsSidebar markdown={NAV} />
          </div>
        </aside>
        <div className="docs-content" ref={proseRef}>
          <Outlet/>
        </div>
        <OnThisPage containerRef={proseRef} watch={location.pathname}/>
      </div>
    </section>
  )
}
